<div class="user-menu-wrapper" *ngIf="user && isLoggedIn">
  <div
    class="user-name"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    style="cursor: pointer"
    routerLink="user"
  >
    <!-- <img
      referrerpolicy="no-referrer"
      src="../../../../../assets/preneed/circle-user.svg"
      alt="عکس کاربر"
    /> -->
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="circle-user" class="blue"></mat-icon>
      <span class="name d-inline-block mx-2" *ngIf="user">{{ user.fullName || "" }}</span>
    </div>

    <jam-icon [size]="30" name="chevron-left"></jam-icon>
  </div>

  <mat-divider class="my-3"></mat-divider>
  <!-- <div class="d-flex flex-column w-100 p-sm-4 p-2 blue-bg">
    <div
      class="d-flex align-items-center w-100 justify-content-between"
    >
      <div class="dflex align-items-baseline">
        <app-wallet-icon></app-wallet-icon>
        <span class="user-name text-white me-3">گردش کیف پول</span>
      </div>
      <jam-icon
        [size]="30"
        name="chevron-left"
        class="white-jam-icon"
      ></jam-icon>
    </div>
    <span class="fs-6 text-white mt-4">
      موجودی : 100,000,000 ریال
    </span>
  </div> -->
  <div class="d-flex flex-column w-100 p-sm-4 p-2 mt-2 red-bg">
    <div
      class="d-flex align-items-center w-100 justify-content-between"
    >
      <div class="dflex align-items-baseline">
        <app-dollar-icon />
        <span class="user-name text-white me-3">گردش امتیازات</span>
      </div>
      <jam-icon
        [size]="30"
        name="chevron-left"
        class="white-jam-icon"
      ></jam-icon>
    </div>
    <span class="fs-6 text-white mt-4">
      تعداد امتیازات : {{user?.score || 0}} ستاره
    </span>
  </div>
  <mat-divider class="my-3"></mat-divider>

  <div
    routerLinkActive="activated"
    routerLink="/user/my-orders"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
    class="user-menu-item"
  >
    <!-- <jam-icon style="margin-left: 10px" name="shopping-bag"></jam-icon> -->
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="cart-check" class="blue mx-0"></mat-icon>
      <span class="name d-inline-block mx-2">سفارش‌های من</span>
    </div>
  </div>

  <div
    routerLink="/user/download-orders"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
    class="user-menu-item"
  >
    <!-- <jam-icon style="margin-left: 10px" name="download"></jam-icon> -->
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="arrow-down-to-bracket" class="blue mx-0"></mat-icon>
      <span class="name d-inline-block mx-2">سفارشات دانلودی</span>
    </div>
  </div>

  <div
    routerLink="/user/wallet"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
    class="user-menu-item"
  >
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="wallet" class="blue mx-0" />
      <span class="name d-inline-block mx-2">کیف پول</span>
    </div>
  </div>

  <div
    *ngIf="user?.role?.code === userRoles.ADMIN"
    routerLink="/admin"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
    class="user-menu-item"
  >
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="mail-check" class="blue mx-0" />
      <span class="name d-inline-block mx-2">پنل مدیریت</span>
    </div>
  </div>
  <!-- <a
    
    color="primary"
    style="color: var(--primary)"
    href="admin"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <jam-icon style="margin-left: 10px" name="activity"></jam-icon>
    <span>پنل مدیریت</span>
  </a> -->

  <button
    color="warn"
    mat-menu-item
    (click)="logoutUser()"
    class="user-menu-item warning w-100"
  >

  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <mat-icon svgIcon="arrow-right-from-bracket" class="warn mx-0"></mat-icon>
      <span class="name d-inline-block mx-2" *ngIf="user">خروج از حساب کاربری</span>
    </div>
    <jam-icon name="chevron-left"></jam-icon>
  </div>
  </button>
</div>

<div class="guest-menu" *ngIf="!isLoggedIn">
  <app-logo *ngIf="isHandset"></app-logo>
  <mat-divider *ngIf="isHandset"></mat-divider>
  <button
    routerLinkActive="activated"
    (click)="openAuthBox()"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <span>ورود به سایت</span>
  </button>
  <button
    routerLinkActive="activated"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <span>درباره ما</span>
  </button>
  <button
    routerLinkActive="activated"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <span>تماس‌ باما</span>
  </button>
</div>
